import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from '../styles/selectField.module.scss'
import Icon from "@/wmCompoments/Icon";
import { useVenueBalanceList } from "@/api/request";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useFormContext } from "react-hook-form";
import SelectPlus from "@/wmCompoments/select";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
}

const SelectField = (props: Props) => {
    const { t } = useTranslation('transferCenter')
    
    const { name } = props

    const {
        register,
        setValue,
        watch,
        trigger,
        clearErrors,
        formState: { errors },
    } = useFormContext();

    const { allBalance } = useVenueBalanceList()

    const list = useMemo(() => {
        if (!allBalance?.length) {
            return []
        }
        return [{
            id: 0,
            zhName: t('centralWallet')
        }, ...allBalance]
    }, [allBalance])

    const value = watch(name);

    useEffect(() => {
        register(name);
    }, [register, name])

    useEffect(() => {
        if (!value?.left || !value?.right) {

            setValue(name, {
                left: list?.[0],
                right: list?.[1]
            })
        } else {
            const left = findItemById(value?.left?.id)
            const right = findItemById(value?.right?.id)
            setValue(name, {
                left,
                right
            })
        }
    }, [list, name])






    const findItemById = (id) => {
        return list?.find((v) => v.id === id);
    }

    const handleChangeLeft = (id) => {
        if (id === value?.left?.id) {
            return
        }
        if (id === value?.right?.id || id === 0) {
            handleExchange()
        } else {
            if (value?.right.id !== 0 && id !== 0) {
                setValue(name, {
                    left: findItemById(id),
                    right: value?.left
                })
            } else {
                setValue(name, {
                    ...value,
                    left: findItemById(id)
                })
            }
        }
    }

    const handleChangeRight = (id) => {
        if (id === value?.right?.id) {
            return
        }
        if (id === value?.left?.id || id === 0) {
            handleExchange()
        } else {
            if (value?.left.id !== 0 && id !== 0) {
                setValue(name, {
                    left: value?.right,
                    right: findItemById(id)
                })
            } else {
                setValue(name, {
                    ...value,
                    right: findItemById(id)
                })
            }
        }
    }

    const handleExchange = () => {
        setValue(name, {
            left: value?.right,
            right: value?.left
        })
    }

    const options = useMemo(() => {
        return list?.map((v) => {
            return {
                ...v,
                label: v.zhName,
                value: v.id
            }
        }) ?? []
    }, [list])

    return <div className={styles.warpper}>
        <div className={styles.warpperSelect} >
            <SelectPlus
                options={options}
                value={value?.left?.id}
                onChange={(v, o) => {
                    handleChangeLeft(v)
                }}
                optionRender={(opt, selected) => (

                    <div className={styles.optionRender}>
                        <span>{opt.label}</span>
                        {selected && <SpriteContainer name="icon_checked" />}
                    </div>
                )}
                labelRender={(opt) => {

                    return (
                        <div className={styles.labelRender}>
                            <span>{opt?.label}</span>
                            <Icon name={'icon-general-arrow-line-right'} className={styles.icon} />
                        </div>
                    )
                }}
                className={styles.select}
            />
            <div onClick={() => handleExchange()}>
                <Icon name="icon-mine-theme" />
            </div>

            <SelectPlus
                options={options}
                value={value?.right?.id}
                onChange={(v, o) => {
                    handleChangeRight(v)
                }}
                optionRender={(opt, selected) => (

                    <div className={styles.optionRender}>
                        <span>{opt.label}</span>
                        {selected && <SpriteContainer name="icon_checked" />}
                    </div>
                )}
                labelRender={(opt) => {

                    return (
                        <div className={styles.labelRender}>
                            <span>{opt?.label}</span>
                            <Icon name={'icon-general-arrow-line-right'} className={styles.icon} />
                        </div>
                    )
                }}
                className={styles.select}
            />
        </div>

        <div className={styles.tips}>
            <span>{t('venueTransferUnsupported')}</span>
        </div>
    </div>
}


export default SelectField